module.exports = __webpack_public_path__ + "static/media/Q5 - Private Oasis.8cb81561.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/Q5 - Private Oasis.png
// module id = 604
// module chunks = 0